import styled, { css } from 'styled-components';

export const Content = styled.input`
  padding: 8px 10px;
  height: auto;
  background-color: #fff;
  border-radius: 3px;
  color: #000;
  border: 1px solid #767676;
  ${(props) =>
    props.theme.theme === 'dark' &&
    css`
      background-color: #4f5761;
      color: #fff;
    `}
`;
